import type { RouteRecordRaw } from 'vue-router'
import { Layout } from '@/utils/routerHelper'

const userRoutes: RouteRecordRaw[] = [
  {
    path: '/user',
    name: 'UserManage',
    component: Layout,
    meta: { title: '用户管理', icon: 'vi-ep:user', alwaysShow: true },
    children: [
      {
        path: 'game-user',
        component: () => import('@/views/Game/GameUserList.vue'),
        name: 'GameUserList',
        meta: { title: '游戏用户' }
      }
    ]
  }
]

export default userRoutes
